import {REFACTOR_URL} from '../../../helpers/env';
import {IInclusions} from '../reducers/inclusionsReducers';

export const inclusionSummary = (token: string, patientId?: number) => {
  console.log(`Service inclusionSummary request start with token ${token} and patientId ${patientId}`)
  const ENDPOINT: RequestInfo = `${REFACTOR_URL}/crm-implantation-enrollment/summary${patientId ? `&patientId=${patientId}` : ''}`
  
  return fetchData(ENDPOINT, token)
}

export const inclusions = (
    token: string,
    limit: number,
    page: number,
    read?: boolean,
    patientId?: number,
) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_URL}/crm-implantation-enrollment?page=${page}&limit=${limit}${read === undefined ? '' : `&read=${read}`}${patientId ? `&patientId=${patientId}` : ''}`
  
  return fetchData(ENDPOINT, token)
}

export const updateInclusionMakerRead = (token: string, implantEnrollmentId: string, maker_readed: boolean) => {
  console.log(`service implantEnrollmentId ${implantEnrollmentId}`)
  const ENDPOINT: RequestInfo = `${REFACTOR_URL}/crm-implantation-enrollment/readed`
  
  const parameters: RequestInit = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Host: `${REFACTOR_URL}`,
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
    body: JSON.stringify({
      implantEnrollmentId,
      maker_readed,
    }),
  }
  
  let status = 0
  return fetch(ENDPOINT, parameters)
      .then((response) => {
        status = response.status
        return response.json()
      })
      .then((data) => {
        return { data, status }
      })
      .catch((e) => {
        console.error(e)
      })
}


const fetchData = (endPoint: string, token: string) : {} => {
  const parameters: RequestInit = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Host: `${REFACTOR_URL}`,
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  }
  
  let status = 0
  
  return fetch(endPoint, parameters)
      .then((response) => {
        status = response.status
        return response.json()
      })
      .then((data) => {
        data.data?.forEach((inclusion: IInclusions) => {
          inclusion.checked = false
        })
        
        return { data, status }
      })
      .catch((e) => {
        console.error(e)
      })
}

export const getFilePdf = (token: string, fileId: number) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_URL}/stored_file/${fileId}`
  
  const parameters: RequestInit = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Host: `${REFACTOR_URL}`,
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  }
  
  let status = 0
  return fetch(ENDPOINT, parameters)
      .then((response) => {
        status = response.status
        return response.blob()
      })
      .then((data) => {
        return { data, status }
      })
      .catch((e) => {
        console.log(`Get fetch error ${e}`)
      })
}
